import {createApp} from 'vue';
import '../styles.css';
import AppVue from './components/App.vue';

createApp(AppVue).mount('#lopaka_app');
